module.exports = __webpack_public_path__ + "img/zt5.8641ccb.png";